// Promise polyfill
import "core-js/features/promise";

import { createRoot } from "react-dom/client";
import App from "./components/App";
import AuthCheck from "./components/AuthCheck";
import { configureAmplify } from "../config/amplify";
import CloudwatchRumWrapper from "./components/cloudwatchRumWrapper";

/* global document, Office, module, require */

const rootElement: HTMLElement = document.getElementById("container");
const root = createRoot(rootElement);

const loadWithoutAwsStack = false;

/* Render application after Office initializes */
Office.onReady(() => {
  if (loadWithoutAwsStack) {
    root.render(<App />);
  } else {
    configureAmplify()
      .then(() => {
        root.render(
          <AuthCheck>
            <CloudwatchRumWrapper>
              <App />
            </CloudwatchRumWrapper>
          </AuthCheck>
        );
      })
      .catch((err) => console.error(err));
  }
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root.render(NextApp);
  });
}
